export { default as GDMDialogContent } from './GDMDialogContent';

export type { GDMDialogContentComponent, GDMDialogContentProps } from './GDMDialogContent.type';
